import { useTranslation } from 'react-i18next';
import type { VehicleInfo } from '../types';
import type { DealerLocationData } from './useGetDealerDetails';

const useCreateMetaDescription = (
  vehicleData: VehicleInfo | undefined,
  dealerInfo: DealerLocationData | undefined,
) => {
  const { t } = useTranslation();

  if (!vehicleData) return t('vdpHeader.metaDescription.noAvailableVehicle');

  const vehicleType = vehicleData.vehicleType;
  const vehicleNumber = vehicleType === 'non-audi' ? vehicleData.stockNumber : vehicleData.audiCode;
  const isNew = vehicleType === 'new';

  const type = isNew ? t('vdpHeader.metaDescription.intro') : t('vdpHeader.preOwned');

  const usedDetails = `${t('vdpHeader.metaDescription.usedDetailsIntro')} ${dealerInfo?.city}, ${dealerInfo?.region}. ${t('vdpHeader.metaDescription.usedDetails')}`;
  const newDetails = `${t('vdpHeader.metaDescription.newDetailsIntro')} ${dealerInfo?.city}, ${dealerInfo?.region}. ${t('vdpHeader.metaDescription.newDetails')} ${vehicleData.dealerName} ${t('vdpHeader.metaDescription.newDetailsSuffix')}`;

  const typeSpecificDetails = isNew ? newDetails : usedDetails;

  return `${type} ${vehicleData.modelName} ${typeSpecificDetails} | ${vehicleNumber}`;
};

export default useCreateMetaDescription;
